/* eslint-disable */
/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import styles from './baseEffort.module.scss';
import dar_pencil from '../../../Assets/images/svg/dar_pencil.svg';
import { OutlinedInput, InputAdornment, IconButton, Select, MenuItem, TextField, Container } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import dar_trash from '../../../Assets/images/svg/dar_delete.svg';
import { removeDefaultStyles } from '../../../Utils/buttonStyle';
import { baseEffortList, savebaseEffort, editbaseEffort, deletebaseEffort } from '../../../Api/request/baseEffort';
import UseAxios from '../../../Api/http/http';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import PuzzleLoader from '../../../Assets/images/svg/loading puzzle.gif';


const BaseEffort = () => {
  const [timeUnits] = useState(['Hour', 'Day', 'Week']);
  const [baseData, setBaseData] = useState([]);
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const permission = userProfile?.permissions
  ? userProfile.permissions[MODULE_NAMES.MASTER_DEAL_EFFORTS] || []
  : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await UseAxios(baseEffortList());
      const resData = res.data.data.baseEffort.map((item) => ({
        ...item,
        unit_type: item.unit_type.charAt(0) + item.unit_type.slice(1).toLowerCase(),
      }));
      setBaseData(resData);
      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching data:', err);
      setIsLoading(false);
    }
  };
  
  const addEfforts = () => {
    setBaseData((prevData) => {
      const maxId = prevData.length > 0 ? Math.max(...prevData.map((item) => item.id)) : 0;
      return [
        ...prevData,
        {
          id: maxId + 1,
          name: '',
          value: '0',
          unit_type: 'Day',
          edit: true,
          isEdit: false,
        },
      ];
    });
  };

  const editEfforts = async (optionId) => {
    setBaseData((prevData) =>
      prevData.map((option) =>
        option.id === optionId ? { ...option, edit: true, isEdit: true } : option
      )
    );  };

  const saveEditEfforts = async (optionId) => {

    const optionToEdit = baseData.find((option) => option.id === optionId);
        
    const payload = {
      id: optionId,
      type: 'Base',
      name: optionToEdit.name,
      value: optionToEdit.value,
      unit_type: optionToEdit.unit_type,
      is_active: true,
    };
    try {      
      await UseAxios(editbaseEffort(payload));
    } catch (error) {
      console.error('Error editing row:', error.message || error);
    }
  };

  // Helper function for saveEffort
  const updateOptionSaveFlag = (optionId) => {
    setBaseData((prevData) =>
      prevData.map((option) =>
        option.id === optionId ? { ...option, edit: false , isEdit: false,} : option
      )
    );
  };

  const saveEffort = (optionId) => {    
    const optionToSave = baseData.find((option) => option.id === optionId);    
    
    const isDuplicatePriority = baseData.some(
      (option) =>
        option.id !== optionId &&
        option.name.toLowerCase().trim() ===
          optionToSave.name.toLowerCase().trim()
    );

    if (isDuplicatePriority) {
      snackbarOpen('Complexity can’t be repeated', 'warning');
      return baseData;
    }
        
    if (!optionToSave.isEdit) {      
    saveRow(optionToSave);
    }
    else {
      saveEditEfforts(optionId);
      updateOptionSaveFlag(optionId);
    }
  };
    
  const deleteEffort = async (optionId) => {
    const optionToDelete = baseData.find((option) => option.id === optionId);
    if (optionToDelete.isEdit) {
      try {
        await UseAxios(deletebaseEffort(optionId));
      } catch (error) {
        console.error('Error deleting effort:', error.message || error);
        return baseData;
      }
    }
    setBaseData((prevData) =>
      prevData.filter((option) => option.id !== optionId)
    );
  };

  const handleFieldChange = (optionId, field, value) => {
    setBaseData((prevData) =>
      prevData.map((option) =>
        option.id === optionId ? { ...option, [field]: value } : option
      )
    );
  };


  // Helper function for handleIncrement
  const handleIncrement = (optionId) => {
    setBaseData((prevData) =>
      prevData.map((option) =>
        option.id === optionId
          ? { ...option, value: (Number(option.value) + 1).toString() }
          : option
      )
    );
  };

  const handleDecrement = (optionId) => {
    setBaseData((prevData) =>
      prevData.map((option) =>
        option.id === optionId
          ? {
              ...option,
              value: Math.max(0, Number(option.value) - 1).toString(),
            }
          : option
      )
    );
  };


  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  const saveRow = async (rowToSave) => {        
    const payload = {
      type: 'Base',
      name: rowToSave.name,
      value: rowToSave.value,
      unit_type: rowToSave.unit_type,
      is_active: true,
    };
    try {
      await UseAxios(savebaseEffort(payload));
      fetchData();
    } catch (error) {
      console.error('Error saving row:', error.message || error);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <img src={PuzzleLoader} alt="Loading..." style={{ width: '100px', height: 'auto' }} />
        </div>
      ) : (
        <div>
          <div className={styles['baseEffort-main']}>
            <div className={styles['baseEffort-main-title']}>{'Scope & Complexity'}</div>
            <button  onClick={() => addEfforts()}
              disabled={!hasAccess('create') || baseData.length >= 4}
              className={styles['baseCalculation-add-btn']}
            >             
            <AddIcon sx={{ fontSize: 20 }} /> 
            <div className={styles['base-effort-button']}>
              Add
            </div>           
            </button>
          </div>
          <div className={styles['baseEffort-options-main']}>
            {baseData.map((option) => (
              <div
               key={option.id}
                className={styles['baseEffort-optionContainer']}
              >
                {option.edit ? (
                  <div>
                    <div className={styles['baseEffort-editRow']}>
                      <Container
                        sx={{ padding: '0px !important', textAlign: 'start' }}
                        className={styles['baseEffort-container']}
                      >
                        <TextField
                          variant="outlined"
                          placeholder="Enter text"
                          sx={{
                            padding: 0,
                            width: '180px',
                            '& .MuiInputBase-root': { height: '32px' },
                          }}
                          value={option.name} // Bind name to TextField
                          onChange={(e) =>
                            handleFieldChange(option.id, 'name', e.target.value)
                          }
                        />
                      </Container>
                      <div>
                        <button style={removeDefaultStyles} onClick={() => deleteEffort(option.id)} disabled={!hasAccess('delete')}>
                          <img
                            src={dar_trash}
                            alt="Trash"
                            className={styles['baseEffort-trashIcon']}
                          />
                        </button>
                      </div>
                    </div>
                    <div className={styles['baseEffort-timeRow']}>
                      <div className={styles['baseEffort-timeWrapper']}>
                        <OutlinedInput
                          value={option.value} // Bind value to OutlinedInput
                          onChange={(e) =>
                            handleFieldChange(option.id, 'value', e.target.value)
                          }
                          onBlur={(e) => handleFieldChange(option.id, 'value', e.target.value.replace(/^0+/, ''))}
                          type="number"
                          startAdornment={
                            <InputAdornment position="start">
                              <IconButton
                                onClick={() => handleDecrement(option.id)}
                                size="small"
                                sx={{ padding: 0 }}
                              >
                                <RemoveIcon fontSize="small" sx={{ fontSize: '14px', color: '#6B5CE8' }} />
                              </IconButton>
                            </InputAdornment>
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => handleIncrement(option.id)}
                                size="small"
                                sx={{ padding: 0 }}
                              >
                                <AddIcon fontSize="small" sx={{ fontSize: '14px', color: '#6B5CE8' }} />
                              </IconButton>
                            </InputAdornment>
                          }
                          sx={{
                            width: '90px',
                            height: '32px',
                            fontSize: '14px',
                            backgroundColor: '#ECEDF4',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#ccc',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            },
                            '& input[type=number]': {
                              MozAppearance: 'textfield',
                            },
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                              {
                                display: 'none',
                              },
                          }}
                          inputProps={{ style: { textAlign: 'center' } }}
                        />
                        <div className={styles['baseEffort-selectWrapper']}>
                          <Container sx={{ padding: '0px !important' }}>
                            <Select
                              value={option.unit_type}
                              onChange={(e) =>
                                handleFieldChange(option.id, 'unit_type', e.target.value)
                              }
                              sx={{
                                width: '80px',
                                height: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: '#ECEDF4',
                                '& .MuiInputBase-input': {
                                  padding: '0px',
                                  textAlign: 'center',
                                },
                                '& .MuiSelect-select': {
                                  height: '32px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  padding: '0px',
                                },
                              }}
                            >
                              {timeUnits.map((unit, idx) => (
                                <MenuItem key={idx + 1} value={unit}>
                                  {unit}
                                </MenuItem>
                              ))}
                            </Select>
                          </Container>
                        </div>
                      </div>
                      <button
                        style={{
                          ...removeDefaultStyles,
                          cursor: !option.name.trim() ? 'not-allowed' : 'pointer',
                          opacity: !option.name.trim() ? 0.5 : 1,
                        }}                        
                        onClick={() => saveEffort(option.id)} // Save changes and set edit to false
                        disabled={!option.name.trim()}
                      >
                        <div className={styles['baseEffort-saveButton']}>Save</div>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className={styles['baseEffort-priorityRow']}>
                      <div className={styles['baseEffort-priorityText']}>{option.name}</div>
                      <button style={removeDefaultStyles} onClick={() => editEfforts(option.id)} disabled={!hasAccess('update')}>
                        <img
                          src={dar_pencil}
                          alt="Edit"
                          className={styles['baseEffort-pencilIcon']}
                        />
                      </button>
                    </div>
                    <div className={styles['baseEffort-timeDisplay']}>                      
                      {option.value} {option.unit_type}
                      {option.value > 1 && 's'}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseEffort;
